import React, { useState } from 'react';
import styled from 'styled-components';
import TextBlock from '@component/common/block/text-block';
import Gap from '@component/common/gap';
import TextButton from '@design-system/text-button';
import type { IFileSavedModalData } from '@datatype/gridgio/type';
import { ETheme } from '@datatype/type';
import * as color from '@constant/color';
import * as size from '@constant/size';
import { openNativeDownload } from '@util/native-file';

interface IProps {
  data: IFileSavedModalData['data'];
}

const Wrapper = styled.div`
  display: flex;
  width: ${size.MEDIUM_MODAL_WIDTH};
  flex-direction: column;
  align-items: center;
`;

const FileSavedModal: React.FC<IProps> = ({ data }) => {
  const [isOpening, setIsOpening] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleOpenDownload = async () => {
    if (isOpening) return;
    setIsOpening(true);
    setErrorMessage('');
    try {
      await openNativeDownload();
    } catch (error) {
      setErrorMessage(error instanceof Error ? error.message : '다운로드 화면을 열지 못했습니다.');
    } finally {
      setIsOpening(false);
    }
  };

  return (
    <Wrapper>
      <TextBlock text='작업 파일을 저장했습니다.' design={{ text: { size: 'medium', color: color.BLACK_2 } }} />
      <Gap height={size.MARGIN_1} />
      <TextBlock text={data.filename} design={{ box: { width: '100%' }, text: { size: 'small', color: color.GRAY_1, oneline: true } }} />
      <Gap height={size.MARGIN_2} />
      <TextButton
        text='다운로드 열기'
        theme={ETheme.CYAN}
        kind='filled'
        size='medium'
        width='100%'
        disabled={isOpening}
        handleClick={() => void handleOpenDownload()}
      />
      {errorMessage && (
        <>
          <Gap height={size.MARGIN_1} />
          <TextBlock text={errorMessage} design={{ text: { size: 'small', color: color.RED_2 } }} />
        </>
      )}
    </Wrapper>
  );
};

export default FileSavedModal;
